import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';

import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacy";
import MapIcon from '@mui/icons-material/Map';
import { Link } from "react-router-dom";
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import NightShelterRoundedIcon from '@mui/icons-material/NightShelterRounded';
import NaturePeopleRoundedIcon from '@mui/icons-material/NaturePeopleRounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';

import Style from "../../styles/js/Styles.js";

import placesService from "../../plas/map/places/service";
import pharmaciesService from "../../plas/map/places/pharmacies/service";

export default function MapMenu( { open, onExpand } ) {

  const style = Style();

  const [expanded, setExpanded] = React.useState(false);
  
  React.useEffect(() => {
    if (!open) {
      setExpanded(false);
    }
  }, [open]);

  const onClick = () => {
    if (!expanded) {
      onExpand();
    }
    setExpanded(!expanded);
  }
  
  return (
    <div>
     { (placesService.canAdmin() || pharmaciesService.canAdmin()) ? (
        <div>
          <ListItem button onClick={onClick}>
            <ListItemIcon>
              <MapIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Lugares" />
            { expanded && open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={expanded && open} timeout="auto" unmountOnExit style={{paddingLeft:"24px"}}>
            <List component="div">
              <div>
                { placesService.canAdmin() && (
                  <>
                    <ListItem button component={Link} to={"/map/places/business"} >
                      <ListItemIcon>
                        <StoreRoundedIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Negocios" />
                    </ListItem>
                    <ListItem button component={Link} to={"/map/places/accommodations"} >
                      <ListItemIcon>
                        <NightShelterRoundedIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Alojamientos" />
                    </ListItem>
                    <ListItem button component={Link} to={"/map/places/institutions"} >
                      <ListItemIcon>
                        <AccountBalanceRoundedIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Instituciones" />
                    </ListItem>
                    <ListItem button component={Link} to={"/map/places/open-air"} >
                      <ListItemIcon>
                        <NaturePeopleRoundedIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Aire libre" />
                    </ListItem>
                      <ListItem button component={Link} to={"/map/places/cultural-spaces"} >
                      <ListItemIcon>
                        <TheaterComedyIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Espacios culturales" />
                    </ListItem>
                  </>
                )}
                { pharmaciesService.canAdmin() ? (
                  <ListItem button component={Link} to={"/map/places/pharmacy-duties"} >
                    <ListItemIcon>
                      <LocalPharmacyIcon/>
                    </ListItemIcon>
                    <ListItemText className={style.menuTextItem} primary="Farmacias de turno" />
                  </ListItem>) : (null)
                }
              </div>
            </List>
          </Collapse>
        </div>) : (null) 
     }
    </div>
    
  );
}
